import {Elements, useStripe} from '@stripe/react-stripe-js';
import { Block } from 'baseui/block';
import { Card } from 'baseui/card';
import {
   Checkbox,
   LABEL_PLACEMENT,
   STYLE_TYPE
} from "baseui/checkbox";
import { Notification } from 'baseui/notification';
import { ListItem } from 'baseui/list';
import { Display2, Paragraph1, Paragraph2 } from 'baseui/typography';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setBillingStatus } from '../actions/ui';
import PaymentPortal from '../billing/PaymentPortal';
import UserApi from '../firebase/UserApi';
import BillingApi from '../firebase/BillingApi';
import withStripe from "../billing/withStripe";


const Account = ({ billingStatus, setBillingStatus }) => {
   const stripe = useStripe();

   const [billingNotifyChecked, setBillingNotifyChecked] = React.useState(true); // TODO we should load this from firestore
   const [promotionalChecked, setPromotionalChecked] = React.useState(true); // TODO we should load this from firestore
   const [expirationDate, setExpirationDate] = React.useState("...");
   const [error, setError] = React.useState(undefined);

   const [transactionDetails, setTransactionDetails] = useState();

   const handleSetBillingStatus = checked => {
      const newBillingStatus = checked ? 'current' : 'inactive';
      setBillingStatus({ status: newBillingStatus });
   }


   const getDollarValue = () => `$${(transactionDetails.amount / 100).toFixed(2)}`;
   const addMonth = () => BillingApi.addMonth(stripe).then(e => console.log(e)).catch(({message}) => window.alert(message))

   useEffect(() => {
      // BillingApi.getStripeDetails('renewSubscription')
      //    .then(async ({data}) => {
      //       setTransactionDetails(data.intent)
      //       const claims = await UserApi.getClaims();
      //       setExpirationDate(new Date(claims.paidThru).toLocaleDateString("en-US"));
      //    })
      //    .catch(setError);
   }, []);

   return (
      <div style={{ width: "100%", margin: "0 5vw 0 5vw" }}>
         <Display2>
            Account Settings
         </Display2>
         <div style={{ margin: "5vw 10vw 5vw 10vw" }}>
            <ListItem>
               <Checkbox
                  checked={billingStatus === 'current'}
                  checkmarkType={STYLE_TYPE.toggle}
                  onChange={e => handleSetBillingStatus(e.target.checked)}
                  labelPlacement={LABEL_PLACEMENT.right}
               >
                  Auto-renew Subscription
               </Checkbox>
            </ListItem>
            {billingStatus !== 'current' ?
               <>
                  <Paragraph1>Expires on {expirationDate}</Paragraph1>
                  <Paragraph2>Add 1 Month to your Subscription - <strong>{transactionDetails ? getDollarValue() : "..."}</strong></Paragraph2>
                  {error ? <Notification kind='negative'>{() => error.message}</Notification> : null}
                  <Card>
                     <Block style={{ padding: '20px' }}>
                        <Elements stripe={stripe}>
                           <PaymentPortal transactionDetails={transactionDetails} onCompleted={addMonth} />
                        </Elements>
                     </Block>
                  </Card>
               </>
               : null
            }
            <ListItem>
               <Checkbox
                  checked={billingNotifyChecked}
                  onChange={e => setBillingNotifyChecked(e.target.checked)}
                  labelPlacement={LABEL_PLACEMENT.right}
               >
                  Billing Notifications
               </Checkbox>
            </ListItem>
            <ListItem>
               <Checkbox
                  checked={promotionalChecked}
                  onChange={e => setPromotionalChecked(e.target.checked)}
                  labelPlacement={LABEL_PLACEMENT.right}
               >
                  Promotions
               </Checkbox>
            </ListItem>
         </div>
      </div>
   )
};

export default connect((state) => {
   return {
      billingStatus: state.ui.billing.status,
   }
}, { setBillingStatus })(withStripe(Account));